export default __webpack_public_path__ + "static/media/action-complete.ebce213c.svg";